import { COLORS } from '.'
import { rem } from 'polished'

const LIBRARIES = ['places', 'geometry', 'drawing']

export const GOOGLE_MAPS_HOOK_PROPS = {
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY || '',
  libraries: LIBRARIES as any,
}

export const TOPBAR_HEIGHT = rem('60px')

export const MAP_SETTINGS = {
  DEFAULT_MAP_OPTIONS: {
    scrollwheel: false,
    mapTypeControl: false,
    fullscreenControl: false,
    streetViewControl: false,
  },
  DEFAULT_CENTER: { lat: 57, lng: 20 },
  DEFAULT_ZOOM: 4,
  MARKER_SIZE: {
    EXTRA_SMALL: 10,
    SMALL: 30,
    MEDIUM: 40,
  },
  PIXEL_OFFSET: {
    MARKER: {
      X: 0,
      Y: -35,
    },
    LINE: {
      X: 0,
      Y: 20,
    },
  },
  POLYLINE_OPTIONS: {
    DASHED: {
      geodesic: true,
      strokeOpacity: 0,
      strokeWeight: 2,
      strokeColor: COLORS.BLUEBERRY_SODA,
      icons: [
        {
          icon: {
            path: 'M 0,0 0,1',
            strokeOpacity: 1,
            strokeWeight: 2,
            scale: 3,
          },
          offset: '0',
          repeat: '10px',
        },
      ],
    },
    REGULAR: {
      geodesic: true,
      strokeOpacity: 1,
      strokeWeight: 2,
      strokeColor: COLORS.EXPLORATION_GREEN,
    },
  },
  DIRECTIONS_OPTIONS: { suppressMarkers: true, preserveViewport: true },
}

export const mealTypes = {
  NO_MEAL: 'No Meal',
  BREAKFAST: 'Breakfast',
  ALL_INCLUSIVE: 'All inclusive',
}

export const tableOrganisation = {
  BANQUET: 'Banquet',
  BROKEN_HORSESHOE: 'Broken Horseshoe',
  CAFE_STYLE: 'Cafe Style',
  CIRCLE: 'Circle',
  CLASSROOM: 'Classroom',
  CLUSTERS: 'Clusters',
  COCKTAIL: 'Cocktail',
  CONFERENCE: 'Conference',
  CRESCENT: 'Crescent',
  HOLLOW_SQUARE: 'Hollow Square',
  IMPERIAL: 'Imperial',
  LOUNGE: 'Lounge',
  POD_SEATING: 'Pod Seating',
  RUNAWAY: 'Runway',
  SEMI_CIRCLE: 'Semi-Circle',
  THEATER: 'Theater',
  THE_DECISION_MAKER: 'The Decision Maker',
  THE_HYBRID: 'The Hybrid',
  THE_INFORMATIONAL: 'The Informational',
  THE_PROBLEM_SOLVER: 'The Problem Solver',
  TIERED_CLASSROOM: 'Tiered Classroom',
  TRIANGLE_CLASSROOM: 'Triangle Classroom',
  U_SHAPE: 'U-Shape',
  X_FORMATION: 'X-Formation',
}

export const PHONE_REGEX =
  /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/

export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'accessToken'
export const LOCAL_STORAGE_CURRENCY_KEY = 'nr-currency'
export const DEFAULT_CURRENCY_ISO_CODE = 'EUR'
export const DEFAULT_CURRENCY_SYMBOL = '€'
export const ENABLED_CURRENCIES = ['EUR', 'GBP', 'USD']

const MB = 1000000
export const MAX_FILE_SIZE = MB * 20
